import { catOf, STATUS, fileUrl } from "@/lib/activity";

export const CategoryBanner = ({ category, status, title, image, compact = false, className, children }) => {
  const c = catOf(category);
  const Icon = c.icon;
  const st = STATUS[status];
  return (
    <div
      className={`relative overflow-hidden text-white ${className || (compact ? "aspect-video rounded-t-3xl" : "aspect-video sm:aspect-[21/9] rounded-3xl")}`}
      style={{ background: `linear-gradient(135deg, ${c.from} 0%, ${c.to} 100%)` }}
      data-testid={`category-banner-${category}`}
    >
      {image ? (
        <>
          <img src={fileUrl(image)} alt={title || c.label} className="absolute inset-0 h-full w-full object-cover object-center" loading="lazy" data-testid="activity-banner-image" />
          <div className={`absolute inset-0 ${compact ? "bg-gradient-to-t from-black/60 via-black/10 to-black/20" : "bg-gradient-to-t from-black/75 via-black/25 to-black/20"}`} />
        </>
      ) : (
        <>
          <div className="absolute inset-0 pattern-overlay opacity-80" />
          <div className="absolute -right-6 -top-6 h-40 w-40 rounded-full bg-white/10 blur-2xl" />
          <p className={`absolute right-5 font-arabic text-white/25 select-none ${compact ? "top-3 text-3xl" : "top-6 text-5xl sm:text-7xl"}`}>{c.arabic}</p>
        </>
      )}
      <div className={`relative h-full flex flex-col justify-between ${compact ? "p-5" : "p-7 sm:p-10"}`}>
        <div className="flex items-center justify-between gap-3">
          <span className="inline-flex items-center gap-2 rounded-full bg-black/25 backdrop-blur px-3 py-1 text-xs font-semibold uppercase tracking-wider">
            <Icon size={14} /> {c.short}
          </span>
          {st && status === "dibatalkan" && !compact && <span className={`rounded-full px-3 py-1 text-xs font-bold ${st.tone}`}>{st.label}</span>}
        </div>
        {!compact && (
          <div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl drop-shadow" data-testid="activity-detail-title">{title}</h1>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};
